import { Account, Calendar } from '../components/AccountCard';
import { CalendarProvider } from './common';

const AUTH_PAUSE_REASONS = ['invalid_auth', 'access_denied', 'invalid_grant'];

export const ACCOUNT_DISCONNECTED_ERROR = 'account_disconnected';

export function isAuthPauseReason(reason: string | null | undefined): boolean {
    if (reason == null) {
        return false;
    }
    if (AUTH_PAUSE_REASONS.includes(reason)) {
        return true;
    }
    return reason.includes('invalid_grant');
}

export function isCalendarInaccessible(calendar: Calendar): boolean {
    return calendar.paused != null && isAuthPauseReason(calendar.paused_reason);
}

export function findCalendarByUuid(
    uuid: string | undefined,
    accounts: Account[],
): { calendar: Calendar; account: Account } | null {
    if (uuid == null) {
        return null;
    }
    for (const account of accounts) {
        const calendar = account.calendars?.find((c) => c.uuid === uuid);
        if (calendar != null) {
            return { calendar, account };
        }
    }
    return null;
}

export function getReconnectTooltipKey(provider: CalendarProvider): string {
    if (provider === CalendarProvider.GOOGLE) {
        return 'dashboard.calendar_inaccessible.tooltip_google';
    }
    if (provider === CalendarProvider.OUTLOOK) {
        return 'dashboard.calendar_inaccessible.tooltip_outlook';
    }
    return 'dashboard.calendar_inaccessible.tooltip_default';
}
